import React, { useEffect, useRef, useState } from 'react';
import ServiceCard from './ServiceCard';
import orientalImage from '../assets/images/Bar-11.webp'; // Replace with actual paths
import ConferenceHall from '../assets/images/hall_9.webp';
import TennisCourt from '../assets/images/Court_1.webp'; // new image
import SpaSteamCenter from '../assets/images/Spa-5.webp'; // Replace with actual paths
import Gym from '../assets/images/Gym-2.webp';
import GardenAreaGrounds from '../assets/images/Garden-5.webp'; // new image
import '../styles/services.css';

  
const Services = ({ language })  => {
    const sectionRef = useRef(null);
      const [visible, setVisible] = useState(false);
    
      // Detect when the section is in the viewport
      useEffect(() => {
        const observer = new IntersectionObserver(
          ([entry]) => {
            if (entry.isIntersecting) setVisible(true);
          },
          { threshold: 0.2 }
        );
    
        if (sectionRef.current) {
          observer.observe(sectionRef.current);
        }
    
        return () => {
          if (sectionRef.current) observer.unobserve(sectionRef.current);
        };
      }, []);

  const services = [
  {
  title: {
    en: 'Conference Hall',
    am: 'ኮንፈረንስ አዳራሽ'
  },
  description: {
    en: 'The Ethiopian Defense Force Officers Club offers versatile conference halls that can accommodate gatherings of all sizes — from intimate meetings to grand events of up to 1000 participants.',
    am: 'የኢትዮጵያ መከላከያ ሠራዊት ኦፊሰሮች ክለብ ለተለያዩ የጉባኤ ይነቶች የሚሆኑ ከመካከለኛ ስብሰባዎች እስከ 1000 ተሳታፊዎች የሚደርሱ ታላላቅ ዝግጅቶችን ጨምሮ  የሚያካትቱ የተለያዩ ላቀ ያለ የኮንፈረንስ አዳራሾችን ያቀርባል።'
  },
  image: ConferenceHall,
  link: '/conference'
},
{
  title: {
    en: 'Bar & Restaurant',
    am: 'ባር እና ሬስቶራንት'
  },
  description: {
    en: 'Our restaurant boasts a clean, modern kitchen operated by skilled chefs and attentive staff committed to excellence. Guests can enjoy a rich menu that blends traditional Ethiopian flavors with a variety of international dishes.',
    am: 'ሬስቶራንታችን በብቃት የተሰለጠኑ ሾፎች እና ሠራተኞች የሚመራበት ንፁህ እና ዘመናዊ ወጥ ቤት አለው። እንግዶች የኢትዮጵያን ባህላዊ ጣዕሞች ከተለያዩ ዓለም አቀፍ ምግቦች ጋር ማጣጣመመ ይችላሉ።'
  },
  image: orientalImage,
  link: '/bar'
},
{
  title: {
    en: 'Spa & Steam Center',
    am: 'ስፓ እና እንፋሎት ማዕከል'
  },
  description: {
    en: 'Designed to promote relaxation and rejuvenation, our spa and steam center features modern facilities including massage rooms, saunas, and steam baths.',
    am: 'መዝናናትን እና እራሰን ለማደስ  የተነደፈው የእኛ እስፓ እና የእንፋሎት ማእከል የማሳጀ ክፍሎችን፣ ሳውናዎችን እና የእንፋሎት መታጠቢያዎችን ጨምሮ ዘመናዊ መገልገያዎችን ይዟል።'
  },
  image: SpaSteamCenter,
  link: '/spa'
},
{
  title: {
    en: 'Gymnasium',
    am: 'ጂምናዚየም'
  },
  description: {
    en: 'Our fully equipped gym is designed to meet the fitness needs of all guests, featuring modern workout machines and free weights, as well as designated spaces for cardio and strength training.',
    am: 'ጂምዕችን የተለያዩ መሳርያዎች የያዘ እና የሁሉንም እንግዶች የአካል ብቃት ፍላጎት ለማሟላት የተነደፈ ሲሆን ዘመናዊ የአካል ብቃት እንቅስቃሴ ማሽኖች እና ነፃ ክብደቶች እንዲሁም ለልብ እና ለጥንካሬ ስልጠና የተመደቡ ቦታዎችን ይዞዕል።'
  },
  image: Gym,
  link: '/gym'
},
{
  title: {
    en: 'Garden Area & Grounds',
    am: 'አረንጓዴ ስፍራ '
  },
  description: {
    en: 'The lush garden grounds of the Officers Club remain beautifully green year-round and serve as a breathtaking venue for outdoor events. Capable of hosting up to 6000-10000 guests, the space is perfect for weddings, concerts, and festivals.',
    am: 'የኦፊሰሮች ክለብ በለሰላላሰ አረንጓዴ መሬት ዕመቱን ሙሉሙሉ በሚያምር ሁኔታ አረንጓዴ ሆኖ ይቆያል። ከ 6000-10000 እንግዶችን ማስተናገድ የሚችለው ይህ ቦታ ለጋብቻዎች፣ ለኮንሰርቶች እና ለፌስቲቫሎች ተስማሚ ነው።'
  },
  image: GardenAreaGrounds,
  link: '/garden'
},
{
  title: {
    en: 'Ground Tennis Court',
    am: 'የሜዳ ቴኒስ ቦታ'
  },
  description: {
    en: 'Our spacious multi-purpose court is ideal for both casual and competitive tennis matches, as well as other recreational activities. Designed with quality materials and ample space.',
    am: 'ሰፊው የሜዳ ቴኒስ ቦታ ለውድድር ለለቴኒስ ጨዋታዎች እንዲሁም ለሌሎች የመዝናኛ እንቅስቃሴዎች ተስማሚ ነው። በብቃት የተሰራ እና በቂ ቦታ ያለው ዲዛይን አለው።'
  },
  image: TennisCourt,
  link: '/tennis'
}
];

  return (
    <section className="py-5 bg-light" id="services">
      <div className="container">
<h2 className="text-center mb-5 fw-bold">
  {language === 'en' ? 'Our Services' : 'የእኛ አገልግሎቶች'}
</h2>
        <div className="row">
          {services.map((service, index) => (
           <div
  className="col-md-6 col-lg-4 mb-4"
  key={index}
  data-aos="fade-up"
  data-aos-delay={index * 100}
>
<ServiceCard
  link={service.link}       // Now handles both string and object
  title={service.title[language]}
  description={service.description[language]}
  image={service.image}
  language={language}       // Crucial for translation selection
/>

</div>

          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;